import React from 'react';
import { Input, Button, Select, Textarea } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { InformationService } from 'services';

interface Props {
	onClose?: any;
	item?: any;
	type?: number;
}

class ModalCreate extends React.Component<Props> {

	state = {
		form: {
			question: '',
			response: ''
		},
		question_label: '',
		response_label: ''
	}

	componentDidMount() {
		if (this.props.item) {
			const item: any = this.props.item;

			this.setState({
				form: {
					...this.state.form,
					question: item?.question || '',
					response: item?.response || '',
				}
			});
		}

		let question_label = '';
		let response_label = '';

		switch(this.props.type) {
			case Constants.INFORMATION_TYPES.QUESTIONS:
				question_label = 'Pregunta';
				response_label = 'Respuesta';
			break;

			case Constants.INFORMATION_TYPES.SUGGESTIONS:
				question_label = 'Sugerencia de actuación';
				response_label = 'Actuación sugerida';
			break;

			case Constants.INFORMATION_TYPES.RESTRICTIONS:
				question_label = 'No debo abordar';
				response_label = 'Respuesta sugerida para el caso';
			break;
		}

		this.setState({
			question_label,
			response_label
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (!this.state.form.question) {
			Globals.showError(`El campo ${ this.state.question_label } es requerido`);
			return;
		}

		if (!this.state.form.response) {
			Globals.showError(`El campo ${ this.state.response_label } es requerido`);
			return;
		}

		if (this.props.item) {
			await InformationService.save({
				...this.state.form,
				information_id: this.props.item?.id,
				type: this.props.type
			});
			this.props.onClose();
			Globals.showSuccess("Se ha modificado la información correctamente");
		}
		else {
			await InformationService.save({
				...this.state.form,
				type: this.props.type
			});
			this.props.onClose();
			Globals.showSuccess("Se ha registrado la información correctamente");
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-create-information">
				<form onSubmit={ this.submit }>
					<div className="row">
						<div className="col-md-12">
							<Input
								value={ this.state.form.question }
								name="question"
								placeholder="Escribir"
								label={ this.state.question_label }
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-12">
							<Textarea
								rows={ 5 }
								value={ this.state.form.response }
								placeholder="Escribir"
								name="response"
								label={ this.state.response_label }
								onChange={ this.change } />
						</div>
					</div>
	      			<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreate;